module.exports = __webpack_public_path__ + "static/media/bannar2.8a392868.webp";